// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {getDealerResults} from '../../shared/repositories';

export const updateDealerResults = params =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const dealers = await getDealerResults(params);

            dispatch({
                dealers,
                type: actions.UPDATE_DEALER_SEARCH_RESULTS_SUCCESS
            });

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/product/dealer-search/action-creators/update-dealer-results.js